import { Box, Skeleton, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import AnalyticError from 'modules/job_catalog/components/RolesTable/Analytics/Error'
import AnalyticTextResult from 'modules/job_catalog/components/RolesTable/Analytics/TextResult'
import AnalyticTimeResult from 'modules/job_catalog/components/RolesTable/Analytics/TimeResult'
import store from 'modules/job_catalog/components/RolesTable/store'
import jobRolesAnalyticsCollection from 'modules/job_catalog/store/collections/rolesAnalytics'
import type JobRole from 'modules/job_catalog/store/models/JobRole'
import GenderStackedBar from 'modules/org_chart/components/GenderStackedBar'

export interface Props {
  role: JobRole
  loading?: boolean
  canSeeAggregatedInfo?: boolean
}

const Row = ({ role, loading, canSeeAggregatedInfo }: Props): JSX.Element | null => {
  if (loading) {
    return (
      <>
        <Table.Cell colSpan={1}>
          <Skeleton width="s32" />
        </Table.Cell>
        {canSeeAggregatedInfo && (
          <Table.Cell colSpan={1}>
            <Skeleton width="s32" />
          </Table.Cell>
        )}
        <Table.Cell colSpan={1}>
          <Skeleton width="s48" />
        </Table.Cell>
        {canSeeAggregatedInfo && (
          <Table.Cell colSpan={1}>
            <Skeleton />
          </Table.Cell>
        )}
      </>
    )
  }

  const roleAnalytics = jobRolesAnalyticsCollection.find({ id: role.id })
  const averageAge = roleAnalytics?.attributes.average_age
  const averageTenure = roleAnalytics?.attributes.tenure
  const genderDiversity = roleAnalytics?.attributes.diversity
  const employeesCountWithThisRole = store.employeesCountByJobRoleId(role.id)

  return (
    <>
      <Table.Cell colSpan={1}>
        <Box flexDirection="row" alignItems="center" justifyContent="center">
          <Text.Normal
            weight="normal"
            color={employeesCountWithThisRole > 0 ? 'grey1000' : 'grey600'}
          >
            {employeesCountWithThisRole}
          </Text.Normal>
        </Box>
      </Table.Cell>
      {canSeeAggregatedInfo && (
        <Table.Cell colSpan={1}>
          <Box flexDirection="row" alignItems="center" justifyContent="center">
            <AnalyticError analytic={averageAge} />
            <AnalyticTextResult analytic={averageAge} />
          </Box>
        </Table.Cell>
      )}
      <Table.Cell colSpan={1}>
        <Box flexDirection="row" alignItems="center" justifyContent="center">
          <AnalyticError analytic={averageTenure} />
          <AnalyticTimeResult analytic={averageTenure} />
        </Box>
      </Table.Cell>
      {canSeeAggregatedInfo && (
        <Table.Cell colSpan={1}>
          <Box flexDirection="row" alignItems="center" justifyContent="center">
            <GenderStackedBar
              results={genderDiversity?.results || []}
              error={genderDiversity?.error?.message}
            />
          </Box>
        </Table.Cell>
      )}
    </>
  )
}

export default observer(Row)
